<template>
    <div>
      <h2>Popup Blocked</h2>
      <p>It seems your browser has blocked our attempt to show you a PDF. Please disable your popup blocker or <a :href="pdfUrl" target="_blank">click here</a> to view the PDF directly.</p>
    </div>
  </template>
  <script>
export default {
  data() {
    return {
      pdfUrl: 'https://www.ftcash.com/app/public/GrievanceRedressalPolicy/ftcash_Customer_Grievance_Redressal_Policy_Version.pdf'
    };
  },
  mounted() {
    window.open(this.pdfUrl, '_blank');
  }
};
  </script>